import { Children } from 'react';

import { ISpecOfferLabel } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { Label } from '@r1-frontend/ui-react/components/label';
import { Clock } from '@r1-frontend/ui-react/components/svg/time';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

interface IProps {
    labels: ISpecOfferLabel[],
}

const LabelsList = ({ labels }: IProps): JSX.Element => {
    return (
        <ListContainer $direction={'row'} $wrap={'nowrap'} $size={8}>
            {Children.toArray(labels.map(({ text, textColor, color: bgColor, type }) => (
                <Label
                    textColor={textColor}
                    bgColor={bgColor}
                >
                    {type === 'timer' && (
                        <Clock size={12} type={'info'}/>
                    )}
                    {text}
                </Label>
            )))}
        </ListContainer>
    );
};

export default LabelsList;
